import checks from "./checks/index.js";
import createMultiple from "./create-multiple.js";
import getMultiple from "./get-multiple.js";
import insertBrickTables from "./insert-brick-tables.js";

export default {
	checks,
	createMultiple,
	getMultiple,
	insertBrickTables,
};
